import clsx from "clsx";
import React from "react";

interface BadgeProps {
  text: string;
  variant: 'success' | 'danger' | 'info' | 'warning' | 'primary' | 'secondary';
  className?: string;
  style?: any;
  isTag?: boolean;
  onClick?: () => void;
}

const Badge: React.FC<BadgeProps> = ({
  text, variant, className, style, isTag, onClick
}) => {
  if (isTag) {
    return (
      <span
        className={clsx(`badge rounded-pill border border-${variant} text-${variant} bg-transparent ${className}`, onClick && 'cursor-pointer')}
        style={style}
        onClick={onClick}
      >
        {text}
      </span>
    );
  }
  return (
    <span className={clsx(`badge ${!style && 'rounded-pill'} bg-${variant} ${className}`)} style={style}>{text}</span>
  );
};

export default Badge;